export default {
  startLoading: ({ commit }) => commit('startLoading'),
  finishLoading: ({ commit }) => commit('finishLoading'),
  callElementToOnBlur: ({ commit }, payload) => commit('callElementToOnBlur', payload)
};
